@if (users?.length) {
  <div class="typing-users">
    {{ users | arrayJoin: { field: 'short_name' } }}
    {{ users.length > 1 ? ('messageCenter.typing_plural' | translate) : ('messageCenter.typing_singular' | translate) }}
  </div>
}
